export const resumePolicyPathNames = {
	resumePolicyDraft: 'resume-pd', // pd - policy draft
	resumeUWCReferredPolicy: 'resume-uwcrp', // uwcrp - under writer continuing referred policy
	resumeUCReferredPolicy: 'resume-ucrp', // ucrp - user continuing referred policy
	resumeUWCEndorsement: 'resume-uwcedr', // uwcedr - under writer continuing endorsement
	resumeUCQuotePolicy: 'resume-ucqp' // ucqp - user continuing quote policy
};

/**
 * Builds the checkout request payload for an endorsement.
 *
 * @param {object} params
 * @param {string} params.policyReferenceId - Policy reference ID (draftPolicy.pathParam2)
 * @param {string} params.policySaleReference - Policy sale reference (draftPolicy.pathParam3)
 * @param {object} params.agentDetails - Agent details from referenceTokenDetails
 * @param {object} params.policyHolderDetails - Policyholder fields from getPolicyHolderDetails
 * @param {boolean} params.isEndorsable - Whether the policy is endorsable
 * @param {object} params.ratingOutfit - Rating outfit from the selected product option/frequency
 * @param {object} params.channelSettings - Channel settings from context
 * @param {string} params.paymentInstanceId - Payment instance ID from resume policy response (draftPolicy.resumePolicyResponse.collsPaymentInstanceId)
 * @param {object} params.existingPolicyPremiumSummary - Pre-endorsement premium breakdown from productPriceNew.value
 */
export const buildEndorseCheckoutBody = ({
	policyReferenceId,
	policySaleReference,
	agentDetails,
	policyHolderDetails,
	isEndorsable,
	ratingOutfit,
	channelSettings,
	paymentInstanceId,
	existingPolicyPremiumSummary
}) => {
	// Spread policyholder fields so the helper owns all field references
	const { phPhoneNumberCode, phPhoneNumber, phEmail, phFirstName, phLastName } = policyHolderDetails;
	const {
		immediateProRataPremium,
		policyCollectionAmount,
		nextCollectionDate,
		recurringPremiumAmount,
		nextCollectionDay,
		annualPremium
	} = ratingOutfit || {};

	return {
		paymentInstanceId: paymentInstanceId || null,
		companyId: agentDetails?.companyInstanceId,
		companyCode: agentDetails?.partnerCode,
		policyReferenceId,
		policySaleReference,
		amount: 0,
		currency: channelSettings?.currencyCode || 'ZAR',
		checkoutType: 0,
		shopperSuccessUrl: ``,
		shopperFailureUrl: ``,
		submitXPayment: false,
		makePolicySalePayment: false,
		defaultPercentage: 100,
		agentName: `${agentDetails?.agentFirstName} ${agentDetails?.agentLastName}`,
		agentEmail: agentDetails?.agentEMail,
		mobile: `+${phPhoneNumberCode}${phPhoneNumber}`,
		email: phEmail,
		debtorName: `${phFirstName} ${phLastName}`,
		isRetry: false,
		endorsementRequest: {
			isEndorsement: isEndorsable,
			immediateProRataPremium: immediateProRataPremium != null ? parseFloat(immediateProRataPremium) : null,
			nextCollectionAmount: policyCollectionAmount != null ? parseFloat(policyCollectionAmount) : null,
			nextCollectionDate: nextCollectionDate ?? existingPolicyPremiumSummary?.nextCollectionDate,
			nextCollectionDay: (() => {
				const day = nextCollectionDay ?? existingPolicyPremiumSummary?.nextCollectionDay;
				return day != null ? parseInt(day, 10) : null;
			})(),
			recurringPremiumAmount: recurringPremiumAmount != null ? parseFloat(recurringPremiumAmount) : null,
			totalAmount: annualPremium != null ? parseFloat(annualPremium) : null
		}
	};
};
